module.exports = wtr_shared_19_5_1;